const presentingComplaintOptions = [
    { label: "Visual disturbances", value: "1" },
    { label: "Pain", value: "2" },
    { label: "Numbness or tingling of hands/feet", value: "3" },
    { label: "Recurrent skin infections", value: "4" },
    { label: "Slow healing Wound/Ulcer", value: "5" },
    { label: "Weight changes", value: "6" },
    { label: "Fatigue/Tiredness", value: "7" },
]

const foot_point_options = {
    foot_point_1_options: [
      {label: "", value: "1"},
    ],
    foot_point_2_options: [
      {label: "", value: "2"},
    ],
    foot_point_3_options: [
      {label: "", value: "3"},
    ],
    foot_point_4_options: [
      {label: "", value: "4"},
    ],
    foot_point_5_options: [
      {label: "", value: "5"},
    ],
    foot_point_6_options: [
      {label: "", value: "6"},
    ],
    foot_point_7_options: [
      {label: "", value: "7"},
    ],
    foot_point_8_options: [
      {label: "", value: "8"},
    ],
    foot_point_9_options: [
      {label: "", value: "9"},
    ],
    foot_point_10_options: [
      {label: "", value: "10"},
    ],
  };

const medicalHistoryComorbidityOptions =[
    { label: "Diabetes", value: "1" },  
    { label: "Hypertension", value: "2" },  
    { label: "Cardiovascular Disease", value: "3" },  
    { label: "Stroke/CVA/TIA", value: "4" },  
    { label: "Chronic Kidney disease", value: "5" },  
    { label: "Obesity", value: "6" },  
    { label: "Dyslipidemia", value: "7" },  
    { label: "HIV", value: "8" },  
    { label: "TB", value: "9" },  
];

const typeOfDiagnosisFoot=[
    {label:"Type 1", value: "1"},
    {label: "Type 2", value: "2"},
    {label:"Family History of Diabetes", value: "3"},
]

const summary_risk_rating_options = [
    {label: "Low", value: "0"},
    {label: "Moderate", value: "1"},
    {label: "High Risk", value: "2"},
    {label: "Active Diabetic Foot Disease", value: "3"},
  ];

  
const footwearWornOftenOptions = [
    {label: "Closed", value: "1"},
    {label: "Open", value: "2"},
    {label: "Correct size", value: "3"},
    {label: "Too large", value: "4"},
    {label: "Too small", value: "5"},
    {label: "Soft upper", value: "6"},
    {label: "Rigid upper", value: "7"},
    {label: "Rigid sole", value: "8"},
    {label: "Flexible sole", value: "9"},
    {label: "Shallow toe box", value: "10"},
]
const footwearFrequentOptions = [
    {label: "Most of the day", value: "1"},
    {label: "Occasionaly on outings", value: "2"},
    {label: "Frequently go without shoes", value: "3"},
]

const asssessmentFootOptions = [
  {label: "Normal", value: "1"},
  {label: "Corns", value: "2"},
  {label: "Calluses", value: "3"},
  {label: "Bunions", value: "4"},
  {label: "Ingrown Toenails", value: "5"},
  {label: "Claw Toes", value: "6"},
  {label: "Flat Foot", value: "7"},
  {label: "Wounds", value: "8"},
  {label: "Ulceration", value: "9"},
  {label: "High Arched foot", value: "10"},
  {label: "Swelling", value: "11"},
]

const nailInfection = [
    {label: "Fungal", value: "1"},
    {label: "Bacterial", value: "2"},
    {label: "Unknown", value: "3"},
    {label: "Oedema", value: "4"},
]

const orthopedicMotionOptions = [
    {label: "Normal", value: "1"},
    {label: "Abnormal", value: "2"},
]

const skinTempratureOptions=[
    {label: "Normal", value: "1"},
    {label: "Warm", value: "2"},
    {label: "Cool", value: "3"},
]

const skinColorOptions=[
    {label: "Normal", value: "1"},
    {label: "Pale", value: "2"},
    {label: "Reddish", value: "3"},
    {label: "Cyanosis", value: "4"},
    {label: "Mottled", value: "5"},
]
const skinInfectionOptions=[
    {label: "Fungal", value: "1"},
    {label: "Bacterial", value: "2"},
    {label: "Unknown", value: "3"},
]
const skinTexttureOptions=[
    {label: "Normal", value: "1"},
    {label: "Thinner", value: "2"},
    {label: "Thickened", value: "3"},
]
const skinMoistureOptions=[
    {label: "Normal", value: "1"},
    {label: "Sweaty", value: "2"},
    {label: "Dry", value: "3"},
]
const skinGradientOptions=[
    {label: "Normal", value: "1"},
    {label: "Abnormal", value: "2"},
]

const vasularPulsesOption=[
    {label: "Normal", value: "1"},
    {label: "Abnormal", value: "2"},
]

const vascularDoppler = [
    {label: "Done", value: "1"},
    {label: "Not applicable", value: "2"},
    {label: "Referred", value: "3"},
];

const vascularLeftOptions=[
    {label: "Mono Phasic", value: "1"},
    {label: "Bi Phasic", value: "2"},
    {label: "Tri Phasic", value: "3"},
    {label: "Inaudible", value: "4"},
]
const vascularRightOptions=[
    {label: "Mono Phasic", value: "1"},
    {label: "Bi Phasic", value: "2"},
    {label: "Tri Phasic", value: "3"},
    {label: "Inaudible ", value: "4"},
]

const vascularAPBI = [
    {label: "Left leg", value: "1"},
    {label: "Right leg", value: "2"},
]

const neuroLogicalStatusLeftOption=[
    {label: "Normal", value: "1"},
    {label: "Abnormal", value: "2"},
]
const neuroLogicalStatusRightOption=[
    {label: "Normal", value: "1"},
    {label: "Abnormal", value: "2"},
]

const footAmputationOptions = [
    {label: "Digits", value: "1"},
    {label: "Foot", value: "2"},
    {label: "BKA", value: "3"},
    {label: "AKA", value: "4"},
]
const currentMedicationsFoot=[
  {label:"Yes", value:"1"},
  {label:"No", value:"2"},
]

const oralMedications=[
  {label:"Oral", value:"Oral"},
  {label:"Injectables", value:"Injectables"},
];

const alcohol_user_foot = [
  {label: "Yes", value: "Yes"},
  {label: "No", value: "No"},
];

const smoker_user_foot = [
  {label: "Yes", value: "Yes"},
  {label: "No", value: "No"},
];

export { 
    presentingComplaintOptions,
    medicalHistoryComorbidityOptions,
    typeOfDiagnosisFoot,
    footwearWornOftenOptions,
    footwearFrequentOptions,
    asssessmentFootOptions,
    nailInfection,
    orthopedicMotionOptions,
    skinTempratureOptions,
    skinColorOptions,
    skinInfectionOptions,
    skinTexttureOptions,
    skinMoistureOptions,
    skinGradientOptions,
    vasularPulsesOption,
    vascularDoppler,
    vascularLeftOptions,
    vascularRightOptions,
    vascularAPBI,
    neuroLogicalStatusLeftOption,
    neuroLogicalStatusRightOption,
    footAmputationOptions,
    foot_point_options,
    summary_risk_rating_options,
    currentMedicationsFoot,
    oralMedications,
    alcohol_user_foot,
    smoker_user_foot,
};